const CATEGORY = "impressum"
const MAXBILDER = 1;
const EXTENSION = "_(c)_stephan_anders.jpg"

// first object is empty
let bilder = [{}]

for (let i = 1; i <= MAXBILDER; i++) {
  bilder.push({
    "1440": require(`../img/1440/${CATEGORY}/${i<10 ? "0" + i : "" + i}${EXTENSION}`),
    "1366": require(`../img/1366/${CATEGORY}/${i<10 ? "0" + i : "" + i}${EXTENSION}`),
    "1280": require(`../img/1280/${CATEGORY}/${i<10 ? "0" + i : "" + i}${EXTENSION}`),
    "1200": require(`../img/1200/${CATEGORY}/${i<10 ? "0" + i : "" + i}${EXTENSION}`),
    "1080": require(`../img/1080/${CATEGORY}/${i<10 ? "0" + i : "" + i}${EXTENSION}`),
    "1024": require(`../img/1024/${CATEGORY}/${i<10 ? "0" + i : "" + i}${EXTENSION}`),
    "0800": require(`../img/0800/${CATEGORY}/${i<10 ? "0" + i : "" + i}${EXTENSION}`),
    "0768": require(`../img/0768/${CATEGORY}/${i<10 ? "0" + i : "" + i}${EXTENSION}`),
    "0667": require(`../img/0667/${CATEGORY}/${i<10 ? "0" + i : "" + i}${EXTENSION}`),
    "0640": require(`../img/0640/${CATEGORY}/${i<10 ? "0" + i : "" + i}${EXTENSION}`),
    "0568": require(`../img/0568/${CATEGORY}/${i<10 ? "0" + i : "" + i}${EXTENSION}`),
    "0480": require(`../img/0480/${CATEGORY}/${i<10 ? "0" + i : "" + i}${EXTENSION}`),
    "0420": require(`../img/0420/${CATEGORY}/${i<10 ? "0" + i : "" + i}${EXTENSION}`),
    "0375": require(`../img/0375/${CATEGORY}/${i<10 ? "0" + i : "" + i}${EXTENSION}`),
    "0360": require(`../img/0360/${CATEGORY}/${i<10 ? "0" + i : "" + i}${EXTENSION}`),
    "0100": require(`../img/0100/${CATEGORY}/${i<10 ? "0" + i : "" + i}${EXTENSION}`)
  })
  bilder[i].max = bilder[i]["1440"]
  bilder[i].min = bilder[i]["0100"]
  bilder[i].srcset=`
    ${bilder[i]["1440"]} 1440w,
    ${bilder[i]["1366"]} 1366w,
    ${bilder[i]["1280"]} 1280w,
    ${bilder[i]["1200"]} 1200w,
    ${bilder[i]["1080"]} 1080w,
    ${bilder[i]["1024"]} 1024w,
    ${bilder[i]["0800"]} 800w,
    ${bilder[i]["0768"]} 768w,
    ${bilder[i]["0667"]} 667w,
    ${bilder[i]["0640"]} 640w,
    ${bilder[i]["0568"]} 568w,
    ${bilder[i]["0640"]} 640w,
    ${bilder[i]["0568"]} 568w,
    ${bilder[i]["0420"]} 420w,
    ${bilder[i]["0375"]} 375w,
    ${bilder[i]["0360"]} 360w`
}

export default bilder



// WEBPACK FOOTER //
// ./src/bilder/impressum.js